var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loader-inline-block' ].concat( _vm.$attrs.class),style:(_vm.$attrs.style)},[_c('img',{attrs:{"src":"/assets/loading.gif"}})])}
var staticRenderFns = []

export { render, staticRenderFns }